import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { WorldMapProvider } from "../../../contexts/WorldMapContext";
import DiseaseZonesBox from "../../../contexts/WorldMapContext/DiseaseZonesBox";
import GoogleMap from "../../../contexts/WorldMapContext/GoogleMap";
import { FactoryMarker, SiteMarker, VesselMarker } from "../../../contexts/WorldMapContext/Marker";
import { SeaWayPolyline } from "../../../contexts/WorldMapContext/Polyline";
import { OPERATION_TYPE } from "../../../util/varibles/constants";
import ProductionAreas from "../../DashboardPage/Map/ProductionAreas";
import ActualDiseasedZone from "../_components/Route/ActualDiseasedzone";
import { selectOpDetail } from "../constants";
import stylesContainer from "../style.module.scss";
import { useProcessData } from "./ProcessDataContext";

function Route() {
    const [start] = useProcessData(state => state.start);
    const [finish] = useProcessData(state => state.finish);
    const actualRoute = useSelector(selectOpDetail.actualRoute);
    const vessel = useSelector(selectOpDetail.vessel);
    const operation = useSelector(selectOpDetail.operation);
    const planRoute = useSelector(selectOpDetail.planRoute)
    const [isTracking, setIsTracking] = useState(false);

    const points = useMemo(() => {
        if (!start || !finish)
            return [];

        const list = actualRoute?.real_route?.points ?? [];
        const result: { lat: number; lng: number }[] = [];

        for (const item of list) {

            const { time } = item;

            if (!time) continue;
            if (time < start) continue;
            if (time > finish) continue;

            result.push({
                lat: +item.latitude,
                lng: +item.longitude,
            });
        }

        return result;
    }, [actualRoute?.real_route, start, finish]);

    const markers = useMemo(() => {
        const { points = [] } = planRoute || {};
        switch (operation.operation_type) {
            case OPERATION_TYPE.HARVEST: {
                const { site, factory } = operation;
                return [
                    <SiteMarker key={site.id} data={{ ...site, position: points[0] }} />,
                    <FactoryMarker key={factory.id} data={{ ...factory, position: points[points.length - 1] }} />
                ]
            }
            case OPERATION_TYPE.TREATMENT: {
                const { site } = operation;
                return [
                    <SiteMarker key={site.id} data={{ ...site, position: points[0] || site.position }} />,
                ]
            }
            case OPERATION_TYPE.TRANSPORT: {
                const { source, destination } = operation;
                return [
                    <SiteMarker key={source.id} data={{ ...source, position: points[0] || source.position }} />,
                    <SiteMarker key={destination.id} data={{ ...destination, position: points[points.length - 1] || destination.position }} />
                ]
            }
            default:
                return []
        }
    }, [operation, planRoute])

    return <div className={`${stylesContainer.section} relative left-1/2 !w-screen -translate-x-1/2 !rounded-none !border-x-0 !border-b-0 !p-0`}>
        <div className="mx-auto flex h-[44px] w-full max-w-[1200px] items-center px-5">
            <div className="text-[20px]">
                Map
            </div>
        </div>
        <div className="h-[calc(80vh-44px)] w-full">
            <GoogleMap
                center={points}
                onDragstart={() => setIsTracking(false)}
            >
                <ActualDiseasedZone diseases={actualRoute.route_diseases || []} />
                <DiseaseZonesBox />
                <VesselMarker data={vessel} showPopup={isTracking} />
                <SeaWayPolyline data={{ points }} color="#56A513" width={3} />
                {markers}
                <ProductionAreas />
            </GoogleMap>
        </div>
    </div>
}

export default function ActualRoute() {
    return <WorldMapProvider>
        <Route />
    </WorldMapProvider>
}
